import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import {deletePubBeerACS} from 'features/beersManager/requestAC';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setModalAC} from 'store/modal/modalSlice';
import '../CheckedBeerInfo/CheckedBeerInfo.scss';

const RemoveMyBeer = () => {
  const {checkedBeer, pubBeers} = useGlobalState((state) => state.beersManager);

  const dispatch = useSetGlobalState();

  const matchingBeer = pubBeers.find((pubBeer) => +pubBeer.id === checkedBeer?.id);

  const handleCancel = () => {
    dispatch(setModalAC(null));
  };

  const handleRemove = () => {
    if (matchingBeer?.id) {
      dispatch(
        deletePubBeerACS({
          pubId: String(matchingBeer.attributes.pub_id),
          beerId: matchingBeer.id,
        }),
      );
    }
    handleCancel();
  };

  return (
    <div className="checked-beer-info">
      <div className="checked-beer-info__header">
        <Text tag="h3">
          Do you want to remove <span>{checkedBeer?.name}</span> beer from your pub?
        </Text>
      </div>
      <div className="checked-beer-info__actions checked-beer-info__actions--confirm">
        <Button variant="tertiary-outlined" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="tertiary-outlined" className="checked-beer-info__remove" onClick={handleRemove}>
          <Icon icon="delete" />
          Remove
        </Button>
      </div>
    </div>
  );
};

export default RemoveMyBeer;
